<div class='d-flex flex-column jusify-content-center align-items-center p-5 w-100 h-100' style="font-size: 1rem;">
    <!-- <img 
    class="mb-3 shadow"
   
    [src]="shop_banner ?? '../../../assets/images/no_card.webp'" 
    alt="Shop Banner" 
    style="max-width: 70%;  height: auto; max-height: 60vh; aspect-ratio: 1.5/1; border-radius: 5px;" 
    /> -->
    <app-biz-name-card id="card-image" [bizCard]="bizCard"></app-biz-name-card>

    <span style="font-weight: bold;">{{bizCard.shop_description ?? ''}}</span>
    <div class='d-flex justify-content-between mt-3' st>
       <button (click)="copyLink()"class='btn mr-5' style='background: #ffffff;  border: 2px solid purple; color: purple;'>
            <i class="fas fa-copy"></i> 
            <span class="bnt-text ml-2">Copy URL</span>
       </button>
       <button (click)="shareURL()" class='btn btn-success' style='background: #8801a0; border: 0;'>
        <i class="fa-solid fa-share"></i>  
        <span class="bnt-text ml-2">Share URL</span>
      </button>
      
    </div>
    

</div>